<template>
  <v-dialog 
  :value="value" 
  @input="$emit('input')"
  transition="fade-transition" 
  scrollable 
  width="800px" >
    <v-card v-if="primaryInf">
      <v-card-title class="card-title-background">
        Merge Influencer
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text style="height: 700px;margin-top:20px;">
        <v-alert
          dense
          text
          type="warning"
        >
          Please check and merge the influencers
        </v-alert>
        <v-expansion-panels v-model="openExpansion" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header class="title">
              Contact Information
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isEmail">
                  <label>Email</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.email"
                    column
                  >
                    <div v-if="primaryInf.email">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.email"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.email">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.email"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="isPhone">
                <v-col cols="12" sm="12" md="6" lg="6">
                  <label>Contact Number</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.phone"
                    column
                  >
                    <div v-if="primaryInf.phone">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.phone"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.phone">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.phone"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="title">
              Billing Information
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isBankName">
                  <label>Bank name</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.bankName"
                    column
                  >
                    <div v-if="primaryInf.bankName">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.bankName"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.bankName">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.bankName"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isBankAccount">
                  <label>Bank account</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.bankAccount"
                    column
                  >
                    <div v-if="primaryInf.bankAccount">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.bankAccount"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.bankAccount">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.bankAccount"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isFullName">
                  <label>Fullname as per Bank Account</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.fullName"
                    column
                  >
                    <div v-if="primaryInf.fullName">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.fullName"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.fullName">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.fullName"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isCountry">
                  <label>Country</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.country"
                    column
                  >
                    <div v-if="primaryInf.country">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.country"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.country">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.country"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
              <v-col cols="12" sm="12" v-if="isMailingAddress">
                <label>Mailing address</label>
                <v-radio-group
                  class="mt-0"
                  v-model="comparisons.mailingAddress"
                  column
                >
                  <!-- <div>{{ primaryInf.mailingAddress }}</div> -->
                  <div v-if="primaryInf.mailingAddress">
                    <v-radio
                      class="pt-1"
                      :label="primaryInf.mailingAddress"
                      color="warning"
                      :value="1"
                    ></v-radio>
                  </div>
                  <div v-if="compareInf.mailingAddress">
                    <v-radio
                      class="pt-1"
                      :label="compareInf.mailingAddress"
                      color="warning"
                      :value="2"
                    ></v-radio>
                  </div>
                </v-radio-group>
              </v-col> 
            </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="title">
              Your Rates <span style="font-size:10px;margin-left:5px;">(in SGD per item)</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs class="mb-3" v-model="tab">
                <v-tab href="#tab-1" v-if="primaryInf.audience">
                  {{primaryInf.audience.user_profile ? primaryInf.audience.user_profile.fullname : ''}}
                </v-tab>
                <v-tab href="#tab-1" v-if="primaryInf.tiktokaudience && !primaryInf.audience && !primaryInf.youtubeaudience">
                  {{primaryInf.tiktokaudience.user_profile ? primaryInf.tiktokaudience.user_profile.fullname : ''}}
                </v-tab>
                <v-tab href="#tab-1" v-if="primaryInf.youtubeaudience && !primaryInf.audience && !primaryInf.tiktokaudience">
                  {{primaryInf.youtubeaudience.user_profile ? primaryInf.youtubeaudience.user_profile.fullname : ''}}
                </v-tab>
                <v-tab href="#tab-2" v-if="compareInf.audience">
                  {{compareInf.audience.user_profile ? compareInf.audience.user_profile.fullname : ''}}
                </v-tab>
                <v-tab href="#tab-2" v-if="compareInf.tiktokaudience">
                  {{compareInf.tiktokaudience.user_profile ? compareInf.tiktokaudience.user_profile.fullname : ''}}
                </v-tab>
                <v-tab href="#tab-2" v-if="compareInf.youtubeaudience">
                  {{compareInf.youtubeaudience.user_profile ? compareInf.youtubeaudience.user_profile.fullname : ''}}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  :key="1"
                  value="tab-1"
                >
                  <inputed-rates
                    :inputedRates="inputedRates"
                  />
                </v-tab-item>
                <v-tab-item
                  :key="2"
                  value="tab-2"
                >
                  <inputed-rates
                    :inputedRates="compareInputedRates"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="title">
              Additional Information
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isGender">
                  <label>Gender</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.gender"
                    column
                  >
                    <div v-if="primaryInf.gender">
                      <v-radio
                        class="pt-1"
                        :label="userGender_options[primaryInf.gender] ? userGender_options[primaryInf.gender] : '-'"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.gender">
                      <v-radio
                        class="pt-1"
                        :label="userGender_options[compareInf.gender] ? userGender_options[compareInf.gender] : '-'"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" v-if="isBirthday">
                  <label>Birthday</label>
                  <v-radio-group
                    class="mt-0"
                    v-model="comparisons.birthday"
                    column
                  >
                    <div v-if="primaryInf.birthday">
                      <v-radio
                        class="pt-1"
                        :label="primaryInf.birthday"
                        color="warning"
                        :value="1"
                      ></v-radio>
                    </div>
                    <div v-if="compareInf.birthday">
                      <v-radio
                        class="pt-1"
                        :label="compareInf.birthday"
                        color="warning"
                        :value="2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>      
      </v-card-text>
      <!-- Footer -->
      <v-card-actions style="margin-right:20px;">
        <v-btn @click="close">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="saveMerge">Save changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import config from '@/config'
import { mapState } from 'vuex';
import InputedRates from '../InputedRates'
export default {
  name: 'ComparisonModal',
  props: {
    value: Boolean,
    influencer: Object,
    compareInf: Object
  },
  components: {
    InputedRates
  },
  data () {
    return {
      openExpansion: [0, 1, 2, 3],
      userGender_options: {},
      inputedRates: {},
      compareInputedRates: {},
      primaryInf: null,
      tab: null,
      comparisonStates: {
        PRIMARY: 1,
        COMPARE: 2
      },
      comparisons: {
        email: 1,
        phone: 1,
        bankName: 1,
        bankAccount: 1,
        fullName: 1,
        country: 1,
        mailingAddress: 1,
        gender: 1,
        birthday: 1
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) this.initData()
    }
  },
  computed: {
    ...mapState({
      savedInfMerge: state => state.influencer.savedInfMerge
    }),
    isEmail() {
      return this.primaryInf.email || this.compareInf.email
    },
    isPhone() {
      return this.primaryInf.phone || this.compareInf.phone
    },
    isBankName() {
      return this.primaryInf.bankName || this.compareInf.bankName
    },
    isBankAccount() {
      return this.primaryInf.bankAccount || this.compareInf.bankAccount
    },
    isFullName() {
      return this.primaryInf.fullName || this.compareInf.fullName
    },
    isCountry() {
      return this.primaryInf.country || this.compareInf.country
    },
    isMailingAddress() {
      return this.primaryInf.mailingAddress || this.compareInf.mailingAddress
    },
    isGender() {
      return this.primaryInf.gender || this.compareInf.gender
    },
    isBirthday() {
      return this.primaryInf.birthday || this.compareInf.birthday
    }
  },
  mounted() {
    // Retrieve gender config
    this.userGender_options = {}
    config.userGenderDisplay.forEach(element => {
      this.userGender_options[element.value] = element.text
    })
  },
  methods: {
    initData() {
      this.inputedRates = Object.assign({}, this.influencer.inputedRates)
      this.compareInputedRates = Object.assign({}, this.compareInf.inputedRates)
      setTimeout(() => {
        this.primaryInf = Object.assign({}, this.influencer)
      }, 1000)
    },
    saveMerge() {
      this.$swal({
        title: 'Double Check!',
        text: `Are you sure to save changes?`,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let saveInf = this.mergeToPrimary()
          let compareInf = null
          if (this.compareInf.tiktok) {
            compareInf = Object.assign({}, {
              id: this.compareInf.influencerID,
              tiktok: this.compareInf.tiktok.id,
              tiktokID: this.compareInf.tiktok.tiktokID,
              tiktokaudience: this.compareInf.audience.id,
              tiktokHandle: this.compareInf.audience.user_profile.username
            })
          } else if (this.compareInf.youtube) {
            compareInf = Object.assign({}, {
              id: this.compareInf.influencerID,
              youtube: this.compareInf.youtube.id,
              youtubeID: this.compareInf.youtube.youtubeID,
              youtubeaudience: this.compareInf.audience.id,
              youtubeHandle: this.compareInf.audience.user_profile.username || this.compareInf.audience.user_profile.custom_name
            })
          } else if (this.compareInf.instagram) {
            compareInf = Object.assign({}, {
              id: this.compareInf.influencerID,
              instagram: this.compareInf.instagram.id,
              instagramID: this.compareInf.instagram.instagramID,
              audience: this.compareInf.audience.id,
              handle: this.compareInf.audience.user_profile.username
            })
          } else if (this.compareInf.facebook) {
            compareInf = Object.assign({}, {
              id: this.compareInf.influencerID,
              facebook: this.compareInf.facebook.id,
              facebookId: this.compareInf.facebook.facebookId,
              handle: this.compareInf.facebook.handle
            })
          } else if (this.compareInf.xiaohongshuID) {
            compareInf = Object.assign({}, {
              id: this.compareInf.influencerID,
              xiaohongshuID: this.compareInf.xiaohongshu.id,
              handle: this.compareInf.xiaohongshu.xhsHandle
            })
          }
          let formData = new FormData()
          formData.append('saveInf', JSON.stringify(saveInf))
          formData.append('compareInf', JSON.stringify(compareInf))
          await this.$store.dispatch('influencer/mergeInf', {
            formData
          })
          if (this.savedInfMerge) {
            this.close()
            this.$emit('mergeSuccess')
          }
        }
      })
    },
    mergeToPrimary() {
      let mergeInf = Object.assign({}, this.primaryInf)
      for (var key of Object.keys(this.comparisons)) {
        if (this.comparisons[key] === this.comparisonStates.COMPARE) {
          mergeInf[key] = this.compareInf[key] || this.primaryInf[key]
        }
      }
      if (this.tab === 'tab-2') {
        mergeInf.inputedRates = this.compareInf.inputedRates || this.primaryInf.inputedRates
      }
      delete mergeInf.audience
      delete mergeInf.tiktokaudience
      delete mergeInf.youtubeaudience
      return mergeInf
    },
    close() {
      this.$emit('showLoading', false)
      this.$emit('input')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ComparisonModal.vue?32ee6408